import * as React from 'react';
import { cn } from '../utils/cn';

// `Omit<…, 'title'>` — lásd Hero.tsx: a natív `title` prop string,
// de mi ReactNode-ot fogadunk (akár ikonnal együtt).
export interface SectionHeadingProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  eyebrow?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  action?: React.ReactNode;
  align?: 'left' | 'center';
}

export function SectionHeading({
  eyebrow,
  title,
  description,
  action,
  align = 'left',
  className,
  ...props
}: SectionHeadingProps) {
  return (
    <div
      className={cn(
        'mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between',
        align === 'center' && 'sm:flex-col sm:items-center sm:text-center',
        className,
      )}
      {...props}
    >
      <div className={cn('flex flex-col gap-2', align === 'center' && 'items-center')}>
        {eyebrow ? (
          <span className="text-xs font-semibold uppercase tracking-widest text-brand-600">
            {eyebrow}
          </span>
        ) : null}
        <h2 className="font-display text-2xl font-bold leading-tight tracking-tight sm:text-3xl">
          {title}
        </h2>
        {description ? (
          <p className="max-w-2xl text-sm text-[var(--color-foreground-muted)] sm:text-base">
            {description}
          </p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
